<template>
    <div class="body">
        <div class="outlineClass">
            <div class="title d-flex justify-content-between align-items-center" style="gap: 10px;">
                <span class="topic"><i class="bi bi-qr-code"></i> QR Scan Result</span>
                <button class="btn btn-danger btn-sm" @click="$emit('close')">
                    <i class="bi bi-x-lg"></i> 
                </button>
            </div>
            
            <div class="itemClass">
                <div v-if="!studentItem || (Array.isArray(studentItem) && studentItem.length === 0)">
                <h5>Not Available This QR</h5>
                </div>

                <div v-else>
                    
                    <div class="form">
                    <!-- Student Details -->
                    <div class="studentDetails">
                        <div v-if="student">
                            <h5 class="text-info"><i class="mainIcon bi bi-person-circle"></i> Student Details</h5>
                            <div class="boxst fs-5 fw-bold text-light">{{ student.first_name }} {{ student.last_name }}</div>
                            <div class="boxst text-light">Grade: <span class="fw-semibold">{{ student.grade_id }}</span></div>
                        </div>
                    </div>

                    <div v-if="studentItem">
                        <div v-for="item in Array.isArray(studentItem) ? studentItem : [studentItem]" :key="item.id" class="boxst text-light">
                            Subject: <span class="fw-semibold">{{ item.subject?.name }}</span>
                            <p hidden><strong>Teacher ID:</strong> {{ item.teacher?.id }}</p>

                        </div>
                    </div>

                    <!-- <div v-if="studentCode" class="mt-2">
                            Student Code: <span class="badge bg-primary p-2">{{ studentCode.wave_code }}</span>
                    </div> -->
                    <div v-if="studentCode" class="mt-2">
  <p class="mb-0">
    <span class="text-light fw-bold me-1">Student Code:</span>
    <span class="badge bg-primary p-2 me-3">{{ studentCode.wave_code }}</span>

    <span class="text-light fw-bold me-1">Reg No:</span>
    <span class="badge bg-success p-2">{{ student.stu_reg_number }}</span>
  </p>
</div>

                
                

                <div v-if="studentItem" class="paymentDetails mt-3">
    <h5><i class="mainIcon bi bi-cash"></i> Payment</h5>
    <div v-for="item in Array.isArray(studentItem) ? studentItem : [studentItem]" :key="item.id" class="paymentClass">
        <div>
            <p>
  <span class="text-warning">Last Payment Date: </span>
  <span class="text-info fw-bold">{{ item.payment_date.split(' ')[0] }}</span>
  <span class="text-secondary ms-2">{{ item.payment_date.split(' ')[1] }}</span>
</p>

            <strong>Status: </strong> 
            <span v-if="isExpired(item.exp_date)" class="text-danger">Expired</span>
            <span v-else-if="item.status === 'pending'" class="text-warning">Pending</span>
            <span v-else class="text-success">Completed</span>
            <div>{{ item.pay_type?.payment_type || 'N/A' }} Payment: <strong>{{ item.amount }}</strong></div>
        </div>
        <!-- {{ item.student_id }} {{ item.id }} -->
          <!-- <button type="button" class="btn btn-info btn-sm" @click="goToStudentPayment(item.id)">
            <i class="bi bi-credit-card"></i> Pay Now
        </button> -->
<!-- Save Button -->
                     
        </div>
        <div class="d-grid gap-2 mt-4">
            <button class="btn btn-primary"  @click="$emit('close')">Close</button>
        </div> 

    </div>
</div>

                
                
            </div>

            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
export default {
    props: {
        qrData: String,  
        student: Object, 
        studentItem: Array, 
        studentCode: Object, 
    },

    data() {
        return {
            // selectedStatus: null,
            isLoading: false,
        };
    },

    methods: {
        isExpired(expDate) {
            if (!expDate) return false;
            return new Date(expDate).getTime() < new Date().getTime();
        },

    }
};
</script>

<style lang="scss" scoped>
.body{
    margin: 2%;
}

.topic{
    font-size: 25px;
}
.outlineClass {
    width: 420px;
    background-color: #1a1a1a;
    color: white;
    border-radius: 15px;
    border: 3px solid #6a11cb;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
    text-align: left;
}
.title {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.4rem;
    padding-bottom: 10px;
    border-bottom: 3px solid #6a11cb;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
h5 {
    color: #00b7ff;
    margin-bottom: 10px;
    font-size: 1.1rem;
}
.studentDetails {
    line-height: 2svh;
}
.boxst {
    width: 80%;
    color: #1a1a1a;
    margin-bottom: 5px;
    padding: 5px;
    border-radius: 5px;
    background: linear-gradient(90deg,#6a11cb,rgb(255, 0, 140));
}
.paymentClass {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.btn-primary {
    width: 100%;
    font-weight: bold;
    background: linear-gradient(90deg, #6a11cb, #2575fc);
    border: none;
    transition: 0.3s;
}
.btn-primary:hover {
    background: linear-gradient(90deg, #2575fc, #6a11cb);
}
.mainIcon {
    margin-right: 8px;
    color: #00b7ff;
}
.badge {
    background-color: #2575fc;
}
.btn-danger {
    background-color: #ff41b0;
    border: none;
}
.btn-danger:hover {
    background-color: #ff6889;
}
textarea.form-control {
    resize: none;
    background-color: #666666;
    color: white;
    border: 1px solid #6a11cb;
}
.dropdown-menu {
    background-color: #1a1a1a;
    border: none;
}
a {
    color: white !important;
}
a:hover {
    color: black !important;
}


@media (max-width: 768px) {

    .body{
    margin: 2%;
}

.topic{
    font-size: 20px;
}

    .outlineClass {
    width: auto;
    border-radius: 15px;
    padding: 10px;
}

}
</style>
